<template>
  <div dir="rtl" class="modal fade forgetpassword-modal  qbank-section" id="show-fav-modal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true" @show.modal="hidePaymentModal">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">قائمة بالاسئلة المفضلة</h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>
        <div class="modal-body">
          <div class="support-box text-center">
            <img class="icon-img text-center" src="assets/img/favourite.png" alt="" />
          </div>
          <h4 class="mb-3 text-center support-text">
            <div class="mb-2">الاسئلة المفضلة</div>
          </h4>

          <div class="notes-container">
            <!-- Loader أثناء التحميل -->
            <div v-if="isLoading" class="text-center py-4">
              <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">جاري التحميل...</span>
              </div>
              <div class="mt-2">جاري تحميل الأسئلة...</div>
            </div>

            <!-- عرض "لا توجد ملاحظات" -->
            <div v-else-if="questionsFavs.length === 0" class="text-center text-muted py-4">
              لا توجد أسئلة مفضلة لك.
            </div>

            <!-- عرض الأسئلة -->
            <div v-else>
              <div v-for="question in questionsFavs" :key="question.id" class="card mb-3 question-card-fav">
                <div class="card-body">
                  <!-- محتوى السؤال -->
                  <p class="fw-bold">{{ question.content }}</p>

                  <!-- عرض الخيارات إذا كان نوع السؤال 1 أو 2 -->
                  <div v-if="question.type === 1 || question.type === 2">
                    <ul v-if="question.choices && question.choices.length" class="list-group mt-2 text-center">
                      <li v-for="choice in question.choices" :key="choice.id" class="list-group-item">
                        {{ choice.content }}
                      </li>
                    </ul>
                  </div>



                  <!-- عرض التاغات إن وُجدت -->
                  <div v-if="question.tags && question.tags.length" class="mt-2">
                    <span v-for="tag in question.tags" :key="tag.id" class="badge bg-success me-1"
                      style="background-color:#0cc336 !important ;">
                      {{ tag.name }}
                    </span>
                  </div>

                  <!-- عرض المصدر -->
                  <small class="text-muted d-block mt-2">
                    المصدر: {{ question.source.name }} - {{ question.source.year }}
                  </small>
                </div>
              </div>


              <!-- عرض الصفحات -->
              <!-- عرض الصفحات -->
              <nav class="mt-4">
                <ul class="pagination justify-content-center">

                  <!-- زر السابق -->
                  <li
                    :class="['page-item', { disabled: !pagination.meta.current_page || pagination.meta.current_page === 1 }]">
                    <button class="page-link" @click="goToPage(pagination.meta.current_page - 1)">
                      &laquo; السابق
                    </button>
                  </li>

                  <!-- أرقام الصفحات -->
                  <li v-for="page in pagination.meta.last_page" :key="page"
                    :class="['page-item', { active: page === pagination.meta.current_page }]">
                    <button class="page-link" @click="goToPage(page)">
                      {{ page }}
                    </button>
                  </li>

                  <!-- زر التالي -->
                  <li :class="['page-item', { disabled: pagination.meta.current_page === pagination.meta.last_page }]">
                    <button class="page-link" @click="goToPage(pagination.meta.current_page + 1)">
                      التالي &raquo;
                    </button>
                  </li>
                </ul>
              </nav>


            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api";

export default {
  name: "Notes",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      isLoading: false,
      questionsFavs: [],
      pagination: {
        links: [],
        meta: {},
      },
      currentPage: 1,
    };
  },
  mounted() {
    this.getFavorites(); // تحميل أولي
  },
  methods: {
    async getFavorites(page = 1) {
      this.isLoading = true;
      this.questionsFavs = [];
      this.currentPage = page;

      try {
        const response = await fetch(`${apiUrl}/qbanks/favourite-questions?page=${page}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          this.questionsFavs = data.data;
          this.pagination.links = data.links;
          this.pagination.meta = data.meta;
        } else {
          console.error("فشل في تحميل البيانات");
        }
      } catch (error) {
        console.error("خطأ أثناء جلب البيانات:", error);
      } finally {
        this.isLoading = false;
      }
    },

    getPageNumber(url) {
      const pageParam = new URL(url).searchParams.get("page");
      return parseInt(pageParam);
    },

    goToPage(page) {
      if (page >= 1 && page <= this.pagination.meta.last_page) {
        this.getFavorites(page);
      }
    },
  },
};
</script>
<style scoped>
.icon-img {
  margin-bottom: 10px;
  width: 60px;
  border-radius: 50%;
  border: 5px solid #55ff4040;
}

.notes-container {
  max-height: 300px;
  overflow-y: auto;
  padding: 5px;
}

.note-card {
  border-right: 1px solid rgb(0, 196, 68);
  border-left: 1px solid rgb(0, 196, 68);
  background-color: #f8f9fa12;
  font-weight: 700;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.note-content {
  word-wrap: break-word;
  white-space: pre-wrap;
  font-size: 14px;
}

.pagination .page-item.disabled .page-link {
  pointer-events: none;
  color: #ccc;
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

.pagination .page-item.active .page-link {
  background-color: #28a745;
  border-color: #28a745;
  color: #fff;
}
</style>
